import { Keyboard } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

export function Footer() {
  return (
    <footer className="flex shrink-0 items-center justify-between gap-2 border-t border-border bg-background/95 px-3 py-1.5 text-2xs text-muted-foreground">
      <div className="flex min-w-0 items-center gap-1.5 truncate">
        <span className="font-medium tracking-tight">DevUtils Sidebar</span>
        {/* The "powered by" credit hides itself on narrow sidebars so the
         *  footer never wraps or overflows. Threshold = 420 px, picked to
         *  leave room for the kbd hint on the right. */}
        <span className="hidden opacity-40 min-[420px]:inline">·</span>
        <a
          href="https://khanhdang.name/"
          target="_blank"
          rel="noopener noreferrer"
          className="hidden truncate text-muted-foreground/70 transition-colors hover:text-foreground min-[420px]:inline"
        >
          powered by <span className="underline-offset-2 hover:underline">khanhdang.name</span>
        </a>
      </div>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className="flex shrink-0 cursor-default items-center gap-1.5">
            <Keyboard className="h-3 w-3" />
            <Kbd>⌘K</Kbd>
            <span className="hidden opacity-60 min-[360px]:inline">to search</span>
          </div>
        </TooltipTrigger>
        <TooltipContent side="top" align="end" className="space-y-1">
          <div>
            <Kbd>⌘K</Kbd> focus search
          </div>
          <div>
            <Kbd>↑</Kbd> <Kbd>↓</Kbd> navigate
          </div>
          <div>
            <Kbd>↵</Kbd> open
          </div>
          <div>
            <Kbd>Esc</Kbd> back / clear
          </div>
        </TooltipContent>
      </Tooltip>
    </footer>
  );
}

function Kbd({ children }: { children: React.ReactNode }) {
  return (
    <kbd className="inline-flex h-4 min-w-[1rem] items-center justify-center rounded border border-border bg-secondary px-1 font-mono text-[10px] leading-none text-secondary-foreground">
      {children}
    </kbd>
  );
}
